export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  useHead({
    script: [
      {
        async: true,
        src: `${config.app.baseURL}pcloud/pay-js-sdk/pay-js-sdk-2.4.2.min.js`.replace(
          /\/+/g,
          '/',
        ),
      },
    ],
  })
})
